import { useState, useEffect } from "react";
import { Row, Col } from "./Flexbox";
import Text from "./Text";
import { CheckCircleOutline, ErrorOutline } from "@mui/icons-material";
import { NotificationManager } from "../scripts/functions/NotificationManager";
import Colors from "../constants/Colors";

const NotificationStack = () => {
    const [notifications, setNotifications] = useState([]);

    //This will detect any push from the manager
    useEffect (() => {
        const handleNewNotification = (newNotif) => {
            setNotifications((prev) => {
                //Add the new one at the top, until there are five
                const updated = [newNotif, ...prev]
                if (updated.length > 5) {
                    updated.pop();  //Delete the last notification
                }
                return updated;
            });

            setTimeout(() => {
                exitAnimation(newNotif.id);
            }, 4700);

            //Remove notifications after 5 seconds
            setTimeout(() => {
                removeNotification(newNotif.id)
            }, 5000);
        }

        NotificationManager.subscribe(handleNewNotification);

        return () => NotificationManager.unsubscribe();
    }, []);

    const exitAnimation = (id) => {
        setNotifications((prev) => prev.map(notif => notif.id === id ? {... notif, exiting: true} : notif))
    }

    const removeNotification = (id) => {
        setNotifications((prev) => prev.filter(n => n.id !== id));
    }

    if (notifications.length === 0) return null;

    return (
        <div style ={{position: 'fixed', top: '100px', right: '20px', zIndex: 9999, display: 'flex', flexDirection: 'column', gap: '10px', pointerEvents: 'none'}}>
            {notifications.map((note) => (
                <div key={note.id} style={{pointerEvents: 'auto', minWidth: '300px', maxWidth: '400px', backgroundColor: note.isSuccess ? Colors.light.Mint : Colors.light.Red, border: `1 px solid ${note.isSuccess ? Colors.light.Verde : Colors.light.Guardsman}`, borderRadius: '8px', padding: '12px 16px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', animation: note.exiting ? 'fadeOut 0.3s ease-out forwards' : 'slideInRight 0.2s ease-out forwards'}}>
                    <Row style={{alignItems: 'center', gap: '12px'}}>
                        {note.isSuccess ? 
                            <CheckCircleOutline style={{color: Colors.light.Verde}}/> :
                            <ErrorOutline style={{color: Colors.light.White}}/>
                        }
                        <Col style={{flex: 1, alignItems: 'flex-start'}}>
                            <Text weight="bold" color={note.isSuccess ? Colors.light.Black : Colors.light.White} size={note.isSuccess ? 14 : 13.5}>
                                {note.message}
                            </Text>
                        </Col>
                        <div onClick={() => removeNotification(note.id)} style={{cursor: 'pointer', color: note.isSuccess ? Colors.light.Black : Colors.light.White}}>x</div>
                    </Row>    
                </div>
            ))}
            <style>{`
                @keyframes slideInRight {
                    from { transform: translateX(100%); opacity: 0; }
                    to { transform: translateX(0); opacity: 1; }
                }
                @keyframes fadeOut {
                    from {transform: translateX(0); opacity: 1;}
                    to {transform: translateX(20px); opacity: 0;}
                }
            `}</style>
        </div>
    )
}

export default NotificationStack;